import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getTalkingPoints, type TalkingPointDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useTalkingPoints(): UseQueryResult<TalkingPointDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.talkingPoints(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getTalkingPoints({ signal }).then((result) => result.data),
    });
}
